const inputLogic = (
    e: KeyboardEvent,
    input: HTMLInputElement,
    inputs: NodeListOf<HTMLInputElement>,
    index1: number,
) => {
    const currentInput = input as HTMLInputElement,
        nextInput = input.nextElementSibling as HTMLInputElement,
        prevInput = input.previousElementSibling as HTMLInputElement;

    if (currentInput.value.length > 1) {
        currentInput.value = "";
        return;
    }

    if (
        nextInput &&
        nextInput.hasAttribute("disabled") &&
        currentInput.value !== ""
    ) {
        nextInput.removeAttribute("disabled");
        nextInput.focus();
    }

    if (e.key === "Backspace") {
        inputs.forEach((input, index2) => {
            if (index1 <= index2 && prevInput) {
                input.setAttribute("disabled", "true");
                input.value = "";
                prevInput.focus();
            }
        });
    }
};

// update hidden field function
const updateHiddenField = (
    inputs: NodeListOf<HTMLInputElement>,
    hiddenField: HTMLInputElement,
) => {
    const values = Array.from(inputs).map((input) => input.value || "");
    hiddenField.value = values.join("");
};

export function otpVerification() {
    const inputs: NodeListOf<HTMLInputElement> = document.querySelectorAll(
        ".otp-form span input",
    );
    const label = document.querySelector<HTMLInputElement>(".otp-form label");
    const hiddenField = document.querySelector<HTMLInputElement>("#code");

    if (inputs.length > 0) {
        // set initial logic on the boxes with inputLogic function
        inputs.forEach((input, index1) => {
            input.addEventListener("keyup", (e) => {
                inputLogic(e, input, inputs, index1);
            });
        });

        // user can also copy & paste the code into the fields
        inputs[0].addEventListener("paste", (event: ClipboardEvent) => {
            event.preventDefault();
            const clipboardData = event.clipboardData;
            if (clipboardData && hiddenField) {
                const inputString = clipboardData.getData("text/plain");
                hiddenField.value = inputString.replace(/\s/g, "");
                inputs.forEach((input, index) => {
                    if (index < inputString.length) {
                        input.value = inputString[index];
                        input.removeAttribute("disabled");
                    }
                });
            }
        });

        // set focus on first box on click on the label when there is no value set
        if (label) {
            label.addEventListener("click", () => {
                let isAnyFieldFilled = false;
                inputs.forEach(function (input) {
                    if (input.value !== "") {
                        isAnyFieldFilled = true;
                        return;
                    }
                });
                if (isAnyFieldFilled) {
                    return;
                }
                inputs[0].focus();
            });
        }

        window.addEventListener("load", () => inputs[0].focus());

        // Sync value of the boxes to the "real" hidden field
        if (hiddenField) {
            // Event-Listener for inputs
            inputs.forEach(function (input) {
                input.addEventListener("input", () => {
                    updateHiddenField(inputs, hiddenField);
                });
            });

            // Initial update
            updateHiddenField(inputs, hiddenField);
        }

        // if you come from complex, congratulations -> you can pass automatically
        const dialog = document.querySelector<HTMLDialogElement>("dialog");
        if (dialog) {
            const loginCodeForComplex =
                document.querySelector<HTMLElement>(".login-code");
            if (loginCodeForComplex && hiddenField) {
                hiddenField.value = loginCodeForComplex.innerHTML.replace(
                    /\s/g,
                    "",
                );
                const digits = loginCodeForComplex.innerHTML.split("");
                inputs.forEach(function (input, index) {
                    input.removeAttribute("disabled");
                    if (input) {
                        input.value = digits[index];
                    }
                });
            }
        }
    }
}
